export default __webpack_public_path__ + "static/media/walletconnect-icon.084eafb0.svg";